export default "__VITE_ASSET__DnIwHydi__"